// extracted by mini-css-extract-plugin
export var actions = "_1j-0";
export var actionsContainer = "_1j-7";
export var border = "_1j-1";
export var childFullHeight = "_1j-f";
export var collapse = "_1j-2";
export var content = "_1j-a";
export var contentChild = "_1j-e";
export var fullscreen = "_1j-c";
export var hasLeftRadius = "_1j-k";
export var headerContainer = "_1j-3";
export var headerRow = "_1j-5";
export var hidePadding = "_1j-b";
export var navCollapsedGap = "_1j-l";
export var noScrollX = "_1j-m";
export var noScrollY = "_1j-n";
export var noTopPadding = "_1j-i";
export var optOutTopPadding = "_1j-d";
export var pageMain = "_1j-j";
export var pageOuter = "_1j-g";
export var pagePadding = "_1j-8";
export var pageScroll = "_1j-9";
export var profile = "_1j-o";
export var profileContainer = "_1j-p";
export var profileImage = "_1j-q";
export var profileMain = "_1j-r";
export var profileSubtitle = "_1j-t";
export var profileTitle = "_1j-s";
export var showLeftPadding = "_1j-h";
export var tabsPortalSlot = "_1j-6";
export var tabsWrapper = "_1j-4";
export var title = "_1j-u";